import React, { useState, useRef, useEffect } from "react";
import { convertToHours, getUKDate, getTimeStamp } from "./functions";

interface FreshnessProps {
  targetFresh: number;
  sentDate: number;
  endHour: number;
}

const Freshness: React.FC<FreshnessProps> = ({
  targetFresh,
  sentDate,
  endHour
}) => {
  const getFreshnessMinutesLeft = () => {
    return Math.round(targetFresh - (Date.now() - sentDate) / 60000);
  };

  const getFreshnessPercentage = () => {
    return Math.round((getFreshnessMinutesLeft() / targetFresh) * 100);
  };

  const [freshPercent, setFreshPercent] = useState<number>(
    getFreshnessPercentage()
  );

  const [freshTimeLeft, setFreshTimeLeft] = useState<number>(
    getFreshnessMinutesLeft()
  );

  const isInsideWindow = () => {
    const now = getUKDate();
    return now.getHours() < endHour;
  };

  const [insideWindow, setInsideWindow] = useState(isInsideWindow());

  const intervalRef = useRef<any>(null);

  const checkFreshness = () => {
    console.log("checkFreshness() at: ", getTimeStamp());
    setFreshPercent(getFreshnessPercentage());
    setFreshTimeLeft(getFreshnessMinutesLeft());
    setInsideWindow(isInsideWindow());
  };

  useEffect(() => {
    checkFreshness();

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      checkFreshness();
    }, 60000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [sentDate]);

  return (
    <div
      className={`freshness${freshPercent <= 0 ? " freshness--alert" : ""}${
        insideWindow ? "" : " freshness--past"
      } `}
    >
      <div className="freshness-time small">
        {`${freshTimeLeft <= 0 ? "00:00" : convertToHours(freshTimeLeft)}`}
      </div>
      <div className="freshness-bar">
        <div
          className={`freshness-bar__energy${
            freshPercent <= 33 ? " bar-low" : ""
          }${freshPercent > 33 && freshPercent <= 66 ? " bar-medium" : ""}${
            freshPercent > 66 ? " bar-high" : ""
          }`}
          style={{
            width: `${freshPercent > 0 ? freshPercent : 0}%`
          }}
        ></div>
      </div>
    </div>
  );
};

export default Freshness;
